<template>
  <div class="music-player bg-black text-white">
    <span>
      <audio ref="audioPlayer" autoplay muted @ended="playNext" >
        <source :src="currentTrack['songurl']" type="audio/mpeg">
      </audio>
    </span>

    <div class="music-info-container">
      <div class="mute-icon-container" v-if="initalised" @click="toggleMute()">
        <span v-if="muted" class="mute-icon">
          <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <path d="M8,14.5792474 L8,21.4207526 L12.4444444,21.4207526 L18,27.1220068 L18,8.87799316 L12.4444444,14.5792474 L8,14.5792474 Z M23,18 C23,15.9874572 21.8666667,14.2485747 20.2222222,13.4104903 L20.2222222,22.5952109 C21.8666667,21.7514253 23,20.0125428 23,18 Z M20.2222222,8 L20.2222222,10.354618 C23.4333333,11.3352338 25.7777778,14.3854048 25.7777778,18 C25.7777778,21.6145952 23.4333333,24.6647662 20.2222222,25.645382 L20.2222222,28 C24.6722222,26.9623717 28,22.8859749 28,18 C28,13.1140251 24.6722222,9.03762828 20.2222222,8 Z" id="path-1"></path>
              </defs>
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Muted" transform="translate(-8.000000, -8.000000)">
                      <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                      </mask>
                      <use id="Volume" fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
                      <path d="M10.5,28 L28,9.5" id="Line" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" transform="translate(19.000000, 18.500000) rotate(-0.000000) translate(-19.000000, -18.500000) "></path>
                  </g>
              </g>
          </svg>
        </span>
        <span v-if="!muted" class="mute-icon">
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                  <path d="M8,14.5792474 L8,21.4207526 L12.4444444,21.4207526 L18,27.1220068 L18,8.87799316 L12.4444444,14.5792474 L8,14.5792474 Z M23,18 C23,15.9874572 21.8666667,14.2485747 20.2222222,13.4104903 L20.2222222,22.5952109 C21.8666667,21.7514253 23,20.0125428 23,18 Z M20.2222222,8 L20.2222222,10.354618 C23.4333333,11.3352338 25.7777778,14.3854048 25.7777778,18 C25.7777778,21.6145952 23.4333333,24.6647662 20.2222222,25.645382 L20.2222222,28 C24.6722222,26.9623717 28,22.8859749 28,18 C28,13.1140251 24.6722222,9.03762828 20.2222222,8 Z" id="path-1"></path>
              </defs>
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Volume" transform="translate(-8.000000, -8.000000)">
                      <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                      </mask>
                      <use fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
                  </g>
              </g>
          </svg>
        </span>
      </div>
      <h3 class="song-name">
        {{ currentTrack['songname'] }}
      </h3>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import axios from 'axios'

export default {
  name: 'MusicPlayer',
  data: function () {
    return {
      muted: false,
      initalised: false,
      playAlbumMode: true,
      currentTrackIndex: 0,
      currentTrack: [{
        'songname': '',
        'url': '/'
      }],
      trackData: [],
      loadingTrackData: true,
      error: null,
      checkDetailsInterval: null
    }
  },
  mounted: function () {
    var self = this


    // Straight forward, give the player a specific track ID to play.
    EventBus.$on('playTrack', (ID) => {
      this.loadTrack(ID);
    })

    //Call this event to initalise the player, once you have authenticated.
    EventBus.$on('initMusicPlayer', () => {
      this.initPlayer();
    })

    // Play next/previous tracks
    EventBus.$on('playNext', () => {
      self.playNext();
    })
    EventBus.$on('playPrev', () => {
      this.loadTrack(this.currentTrackID - 1);
    })

    // We constantly check to see if details have been set.
    // Once we have the details stored in the window, we stop checking.
    window.detailsTimer = window.setInterval(function () {
      if(window.userType != null || self.isUserInApp() === true){
        if(window.userType === 'spotifyPremium' && self.isUserMobile() === false){
          EventBus.$emit('initSpotify');
          EventBus.$emit('connected');
        }
        if(window.userType === 'free'){
          //EventBus.$emit('initSpotify');
          //self.initPlayer();
          EventBus.$emit('connected');
        }
        /*
        if(self.isUserMobile() === true){
          window.userType = 'free';
          self.initPlayer();
          EventBus.$emit('connected');
        }
        */
        if(window.userType === 'Apple'){
          self.initPlayer();
        }
        if(self.isUserInApp() === true){
          clearInterval(window.detailsTimer)
        }
        clearInterval(window.detailsTimer);
      }
    }, 600)


    //DEV MODE
    //this.initPlayer();

  },
  methods: {
    //-----------------
    // SNIFF OUT MOBILE / TABLET DEVICES
    //-----------------
    isUserMobile: function() {
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
          return true;
      }else {
        return false;
      }
   },

    //--------------------
    // DETECT IN APP BROWSERS
    //--------------------
    // Listen for the 'User In App' message in your app.
    // Best to display a message to the user telling them
    // We do not support in app browsers.
    isUserInApp: function() {
      if (navigator.userAgent.indexOf("cordova") !== -1) {
        EventBus.$emit('userInApp');
        return true;
      }else{
        return false;
      }
    },


    // ------------------
    // CREATE / BOOT THE MUSIC PLAYER
    // ------------------
    initPlayer: function () {
      let self = this
      if (self.initalised === false) {
        // Load the track list data, then...
        this.getTrackListData().then(function (res) {
          // Store the track list at the component level.
          self.trackData = res

          // If using apple music, we want to 'listen' for the end of the song.
          // We also want them to follow Celine Dion on apple music
          if (window.userType === 'Apple') {
            appleMusicKit.saveAlbum('1480315784');
            appleMusicKit.amk.player._registry.playbackTimeDidChange.push(function (event) {
              if (typeof event !== 'undefined' && event.currentPlaybackTimeRemaining === 0 && isNaN(event)) {
                self.playNext();
              }
            })
          }

          if (window.userType === 'Spotify' || window.userType === 'spotifyPremium'){
              const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.spotifyAuthToken
              }

              // Follow celine 
              axios.put('https://api.spotify.com/v1/me/following?type=artist&ids=4S9EykWXhStSc15wEx8QFK', '', {
                headers: headers
              })
              .then((response) => {
                console.log(response);
              })
              .catch((error) => {
                console.log(error)
              })

              // Save album to user 
              axios.put('https://api.spotify.com/v1/me/albums?ids=0mqNgHFh1NYaxmlMS5IeGc', '', {
                headers: headers
              })
              .then((response) => {
                console.log(response);
              })
              .catch((error) => {
                console.log(error)
              })
          }

          self.initalised = true
          if(self.playAlbumMode === true){
            setTimeout(() => self.loadTrack(self.currentTrackIndex), 6000);
          }else{
            setTimeout(() => self.loadTrack(), 200);
          }

        })
      }
    },

    // --------------------
    // LOAD THE TRACK DATA
    // --------------------
    getTrackListData: async function () {
      this.loadingTrackData = true;
      var rand = Math.floor(Math.random());
      try {
        let res = await axios({
          url: '/data/tracks/tracks.json?v=' + rand,
          method: 'get',
          timeout: 8000,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        this.loadingTrackData = false
        return res.data
      } catch (error) {
        this.error = 'There was an error loading the song data file.'
      }
    },

    // ------------------------------
    // The Meat and bones of my baby
    // ------------------------------
    loadTrack: function (ID) {
      if (this.loadingTrackData === false) {
        if (this.initalised === false) {
          this.initPlayer()
        }

        var self = this;
        let userType = window.userType;
        var indexOfSongToPlay;
        var trackType;
        let songname;
        let songURL;

        // ---------
        // If you don't pass an ID to this method, we generate one randomly.
        // --------
        if (typeof ID !== 'undefined') {
          indexOfSongToPlay = ID;
        } else {
          indexOfSongToPlay = Math.floor(Math.random()*(this.trackData.length));
        }

        self.currentTrackIndex = indexOfSongToPlay;

        // ----------
        // DECIDE HOW TO PLAY THE MUSIC
        // ----------
        if (window.userType === 'Apple') {
          console.log('Attempting to stream via Apple Music');
          songname = this.trackData[indexOfSongToPlay]['songname']
          songURL =  this.trackData[indexOfSongToPlay]['apple']

          console.log(songname);
          console.log(songURL);
          appleMusicKit.playItem(songURL, 'song')
          EventBus.$emit('songUpdated', indexOfSongToPlay)
        }

        // If the user is a Spotify Premium member, use the Spotify SDK
        if (window.userType === 'spotifyPremium') {
          songname = this.trackData[indexOfSongToPlay]['songname']
          songURL = this.trackData[indexOfSongToPlay]['spotify']

          // Set the objects props, forcing vue to update
          this.spotifyPlay(songURL)
        }

        // If the user is free / hatch - We use the Spotify Free / Preview player.
        if (window.userType === 'free' || window.userType === 'mobile' || !window.userType ) {
          songname =  this.trackData[indexOfSongToPlay]['songname'];
          songURL =   this.trackData[indexOfSongToPlay]['hatch'];

          // If the URL is not valid, we force it to use the ID of a song we KNOW has a spotify link.
          if(songURL === undefined){
            indexOfSongToPlay = 1;
            songURL =  self.trackData[1][trackType];
          }

          this.$refs.audioPlayer.load();
          var promise = this.$refs.audioPlayer.play();
          var self = this;
          if (promise !== undefined) {
              promise.then(_ => {
                  self.error = null;
                  EventBus.$emit('songUpdated', indexOfSongToPlay);
              }).catch(error => {
                  console.log(error);
                  //DOM Exception literally means the user did not interact with any dom elements/click on the page.
                  self.error = "Dom exception";
              });
          }else{
            console.log('Dom Exception');
          }
        }

        this.$set(this.currentTrack, 'songname', songname);
        this.$set(this.currentTrack, 'songurl', songURL);
      }
    },

    playNext: function () {

      console.log('playNext called');
      // Check if the next song would be out of bounds of the array
      if(this.currentTrackIndex + 1 === this.trackData.length){
        console.log('we can play the first track');
        this.currentTrackIndex = 0;
      }else{
        console.log('we can play next track');
        this.currentTrackIndex++;
      }

      // We check if we are in album playing mode or standard mode
      if(this.playAlbumMode === true){
        this.loadTrack(this.currentTrackIndex);
      }else{
        this.loadTrack();
      }
    },

    // ---------
    // MUTE / UNMUTE EACH SERVICE
    // ----------
    toggleMute: function () {
      if (window.userType === 'Apple') {
        if (this.muted === true) {
          appleMusicKit.amk.player.volume = 1
        } else {
          appleMusicKit.amk.player.volume = 0
        }
      }
      if (window.userType === 'spotifyPremium') {
        if (this.muted === true) {
          this.spotifyVolume(100)
        } else {
          this.spotifyVolume(0)
        }
      }
      if (window.userType === 'free' || window.userType === 'mobile' || !window.userType) {
        if (this.muted === true) {
          this.$refs.audioPlayer.muted = false
        } else {
          this.$refs.audioPlayer.muted = true
        }
      }
      this.muted = !this.muted
    },

    // ------------------
    // SPOTIFY WEB SDK PLAYER
    // ------------------
    // - Device_ID is the Spotify generated ID for your player. This should never be null.
    // - trackID is the ID of the track within your track.json file.
    spotifyPlay: function (trackID) {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + window.spotifyAuthToken
      }

      const data = { 'uris': ['spotify:track:' + trackID] }

      if (window.spotifyDeviceID === null) {
        this.initPlayer()
      } else {
        axios.put('https://api.spotify.com/v1/me/player/play?device_id=' + window.spotifyDeviceID, data, {
          headers: headers
        })
        .then((response) => {
          // console.log('Response: ' + response)
        })
        .catch((error) => {
          console.log(error)
        })
      }
    },

    // ------------------
    // SPOTIFY WEB SDK VOLUME CONTROL
    // ------------------
    // It's called in the mute method, ok...
    spotifyVolume: function (volume) {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + window.spotifyAuthToken
      }

      const data = { 'volume_percent': volume }

      axios.put('https://api.spotify.com/v1/me/player/volume?volume_percent=' + volume + '&device_id=' + window.spotifyDeviceID, data, {
        headers: headers
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>


<style lang="scss">


</style>
